import { useEffect, useState } from 'react';
import { pdfjs, Document, Page } from 'react-pdf';
import terms from '../utils/terms.pdf'
import 'react-pdf/dist/Page/TextLayer.css';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import { useRecoilState } from 'recoil';
import manualTypeAtom from '../atoms/manualTypeAtom';
import manualsAtom from '../atoms/manualsAtom';
import { url } from '../utils/config';
import navHeaderAtom from '../atoms/navHeaderAtom';

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
    'pdfjs-dist/build/pdf.worker.min.js',
    import.meta.url,
).toString();

const options = {
    cMapUrl: '/cmaps/',
    standardFontDataUrl: '/standard_fonts/',
};

function Manual() {
    const [ manualType ] = useRecoilState(manualTypeAtom);
    const [ manual ] = useRecoilState(manualsAtom)
    const [ pageNumber, setPageNumber ] = useState(1);
    const [ numPages, setNumPages ] = useState(null);
    const [ header, setHeader ] = useRecoilState(navHeaderAtom)

    useEffect(() => {
        setHeader('Manual')
    }, [])


    function onDocumentLoadSuccess({ numPages }) {
        setNumPages(numPages);
    }

    return(
        <div className='p-3 mih-h-screen h-auto'>
            <div className="text-lg text-center font-semibold py-4 font-family-audiowide">MANUAL</div>
            <div className='flex justify-center'>
                <Document 
                    file={manualType === 'user' ? 
                        (manual?.userManual ? url + '/manual/' + manual.userManual : '') 
                        : 
                        (manual?.technicianManual ? url + '/manual/' + manual.technicianManual : '')
                    } 
                    onLoadSuccess={onDocumentLoadSuccess} 
                    options={options}>
                    {Array.from(new Array(numPages), (el, index) => (
                        <Page
                            key={`page_${index + 1}`}
                            pageNumber={index + 1}
                            scale={0.6}
                        />
                    ))}
                </Document>
            </div>
        </div>
    )
}

export default Manual;
